var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "876px",
    height: "876px",
    viewBox: "0 0 876 876",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cloud3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748,382 C747.809616,366.771557 739.923728,353.182286 728.490693,349.919903 C726.687059,349.404107 724.883425,349.182624 723.119872,349.213552 C719.392361,336.24184 711.085625,325.99277 700.313922,322.917949 C689.301735,319.775287 678.43985,324.905309 671.215294,335.195283 C669.050934,333.52618 666.676149,332.272108 664.110981,331.540816 C652.677945,328.278433 640.884183,342.217886 648.329183,353.548431 L748,382",
    id: "Fill-19",
    fill: "#FFFCFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud3);
export default __webpack_public_path__ + "static/media/Cloud3.0f483fd332525690dffc9270716212dc.svg";
export { ForwardRef as ReactComponent };